<template>
  <AttrSelect
    label="换行"
    :value="shape.attrs.longMode ?? 'clip'"
    :disabled="
      !!attrDisabled ||
      shape.attrs.sizeContent ||
      shape.attrs.style != 'normal' ||
      disabled
    "
    :tooltip="'不换行时，文本超长时，文本会被截断'"
    :options="longModeOptions"
    @change="(val:any)=> shape.setAttrs({'longMode':val})"
  />
</template>
<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { useEditorStore } from '@/store/use-editor-store';
import { PropType, computed } from 'vue';
defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

const longModeOptions = computed(() => {
  return [
    {
      label: '不换行',
      value: 'clip'
    },
    {
      label: '自动换行',
      value: 'wrap'
    }
  ];
});
</script>

<style lang="less" scoped></style>
